//TODO: temp file to get the tests resolved. will need to find a better place
import {MarkupType} from "../../../../../../../../generated/api/base";

// Updated markup type names for V5
export type MarkupTypeName =
	| "Cloud"
	| "Arrow"
	| "Bidirectional Arrow"
	| "Line"
	| "Dashed Line"
	| "Pencil Markup"
	| "Highlight Markup"
	| "Text Box"
	| "Rectangle"
	| "Ellipse"
	| "Triangle"
	| "Cross Markup"
	| "Linear Distance"
	| "Rectangle Area"
	| "Nonlinear Distance"
	| "Irregular Area"
	| "Stamp"
	| "Photo"
	| "Callout"
	| "360 Photo Markup";

// V5 Markup typenames to type mapping
export const MarkupTypenameToType: Record<MarkupTypeName, MarkupType> = {
	Cloud: MarkupType.Cloud,
	Arrow: MarkupType.Arrow,
	"Bidirectional Arrow": MarkupType.BidirectionalArrow,
	Line: MarkupType.Line,
	"Dashed Line": MarkupType.DashedLine,
	"Pencil Markup": MarkupType.PencilDrawing,
	"Highlight Markup": MarkupType.HighlightDrawing,
	"Text Box": MarkupType.TextBox,
	Rectangle: MarkupType.Rectangle,
	Ellipse: MarkupType.Ellipse,
	Triangle: MarkupType.Triangle,
	"Cross Markup": MarkupType.Cross,
	"Linear Distance": MarkupType.LinearDistance,
	"Rectangle Area": MarkupType.RectangleArea,
	"Nonlinear Distance": MarkupType.NonlinearDistance,
	"Irregular Area": MarkupType.IrregularArea,
	Stamp: MarkupType.Stamp,
	Photo: MarkupType.Photo,
	Callout: MarkupType.Callout,
	"360 Photo Markup": MarkupType.Photo360,
};
